import React, { useEffect, useState } from "react";
import { getPurchaseOrder } from "../../actions/project-management.action";
import idx from "idx";
import { numberFormat } from "../../util/currency-formatter";
import moment from 'moment';
import { Modal, Button, Table } from 'react-bootstrap';
import { useDispatch } from "react-redux";

function ViewPOModal({ show, onHide, poId }) {
    const [PO, setPO] = useState({});
    const [vendorType, setvendorType] = useState();
    const [total, setTotal] = useState(0);
    const [attachments, setAttachments] = useState([]);
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch();

    useEffect(() => {
        if (poId && show) {
            getPO();
        }
    }, [poId, show]);

    const getPO = async () => {
        setLoading(true);
        try {
            const query = `?poId=${poId}`;
            let res = await dispatch(getPurchaseOrder(query));
            setPO(res);
            setvendorType(idx(res, (_) => _.vendor.type));
            let totalCost = 0;
            Array.isArray(res.items) && res.items.forEach(({ total }) => (totalCost += total));
            setTotal(totalCost);
            const attachment = res && res.attachment && res.attachment.map(item => {
                return (
                    <div key={item.id || item.name} className="attachedFiles">
                        <p style={{ margin: '0 10px 0 0' }}>{item.name}</p>
                    </div>
                )
            });
            setAttachments(attachment);
        } catch (error) {
            console.error("Error fetching PO details:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="purchase-order-modal"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="purchase-order-modal" className='brand-color-3'>
                    Purchase Order Details
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center p-4">Loading purchase order details...</div>
                ) : (
                    <>
                        <div className="row">
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Purchase Order Number</label>
                                    {/* fId is the PO number with project prefix and Suffix if null then default to po Number*/}
                                    <p>{PO.f_id || PO.id}</p>
                                </div>
                            </div>
                            {/* <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Procurement Code</label>
                                    <p>{PO.f_id}</p>
                                </div>
                            </div> */}
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Vendor Type</label>
                                    <p>{vendorType}</p>
                                </div>
                            </div>
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Vendor Name</label>
                                    <p>{idx(PO, (_) => _.vendor.business_name) || "-"}</p>
                                </div>
                            </div>
                            {idx(PO, _ => _.rfq.description) && <div className="col-lg-4 mt-3">
                                <div className="view-block">
                                    <label>Description</label>
                                    <p>{idx(PO, _ => _.rfq.description)}</p>
                                </div>
                            </div>}
                            {idx(PO, _ => _.quotation.id) && <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Quote Request No</label>
                                    <p>{idx(PO, _ => _.quotation.id)}</p>
                                </div>
                            </div>}
                            {PO.quoteNo && <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Quote No</label>
                                    <p>{PO.quoteNo}</p>
                                </div>
                            </div>}
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Delivery Option</label>
                                    <p>{idx(PO, (_) => _.deliveryOption) || "-"}</p>
                                </div>
                            </div>
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Delivery Date</label>
                                    <p>{idx(PO, (_) => _.deliveryDate) ? moment(idx(PO, (_) => _.deliveryDate)).format('DD/MM/YYYY') : "-"}</p>
                                </div>
                            </div>
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Notes</label>
                                    <p>{idx(PO, (_) => _.notes) || "-"}</p>
                                </div>
                            </div>
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Street Address</label>
                                    <p>{idx(PO, (_) => _.street_address) || "-"}</p>
                                </div>
                            </div>
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Suburb</label>
                                    <p>{idx(PO, (_) => _.suburb) || "-"}</p>
                                </div>
                            </div>
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>State</label>
                                    <p>{idx(PO, (_) => _.state) || "-"}</p>
                                </div>
                            </div>
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Postcode</label>
                                    <p>{idx(PO, (_) => _.postcode) || "-"}</p>
                                </div>
                            </div>
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Country</label>
                                    <p>{idx(PO, (_) => _.country) || "-"}</p>
                                </div>
                            </div>
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Total</label>
                                    <p>{numberFormat(total)}</p>
                                </div>
                            </div>
                            <div className="col-lg-4 mt-3">
                                <div className="view-block">
                                    <label>Attachments</label>
                                    <p>{(attachments && attachments.length > 0) ? attachments : "No attachments"}</p>
                                </div>
                            </div>
                        </div>

                        <div className="material-list-block mt-3">
                            <div className="table-responsive">
                                <Table bordered className="table-create table-material table-material-ch">
                                    <thead>
                                        <tr>
                                            <th className="w-auto">Item</th>
                                            <th className="w-auto">Manufacturer</th>
                                            <th>Part No</th>
                                            <th>Qty</th>
                                            <th className="text-right">Quotation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {PO.is_uploaded_cost ? (
                                            <tr>
                                                <td colSpan={5} className="text-center py-3" style={{ color: "#495057", fontWeight: "500" }}>
                                                    This is a virtual purchase order for direct cost attribution. Items are directly recorded on the vendor invoice.
                                                </td>
                                            </tr>
                                        ) : (
                                            PO.items.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.item}</td>
                                                    <td>{item.manufacturer}</td>
                                                    <td>{item.partNo}</td>
                                                    <td>{item.qty}</td>
                                                    <td className="text-right">{numberFormat(item.total)}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button className='btn-bg-brand-5 btn-border-none' onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ViewPOModal; 